import React from "react";
import Layout from "../../layout/builders/Layout";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import ProjectEnquiryTile from "../../layout/builders/ProjectEnquiry/ProjectEnquiryTile";

const ProjectEnquiry = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Layout>
        <div className="mb-4">
          <ProjectBanner
            title="Project Enquiry"
            imageUrl="https://via.placeholder.com/1200x300"
          />
        </div>
        <div className="px-2 lg:px-4">
          <ProjectEnquiryTile />
        </div>
      </Layout>
    </div>
  );
};

export default ProjectEnquiry;
